import { createApi } from '@reduxjs/toolkit/dist/query/react';

// eslint-disable-next-line import/no-cycle
import { baseQueryWithErrorHandling } from './baseQuery';

export const baseApi = createApi({
  reducerPath: 'baseApi',
  // Add more tag types as needed
  tagTypes: [
    'Sequence',
    'SequenceEmails',
    'Tasks',
    'Unified Inbox',
    'Clients Management',
    'Lead Finder',
    'Prospects',
    'Email Accounts',
    'Template',
    'Reports',
  ],
  baseQuery: baseQueryWithErrorHandling,
  endpoints: () => ({}),
  // keeping this prop value to 0, which means no api will be cached,
  // if you wants to enable caching for any api then pass this prop with the ttl
  // ex. keepUnusedDataFor: 60 - means api response will cached for 60 sec
  keepUnusedDataFor: 0,
});
